import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

export default function ExamTimer({ seconds, onExpire, running }) {
  const [time, setTime] = useState(seconds);

  useEffect(() => {
    if (!running) return;
    setTime(seconds);
  }, [seconds, running]);

  useEffect(() => {
    if (!running) return;
    if (time <= 0) {
      onExpire && onExpire();
      return;
    }
    const timer = setTimeout(() => setTime(t => t - 1), 1000);
    return () => clearTimeout(timer);
  }, [time, running, onExpire]);

  const min = Math.floor(time / 60);
  const sec = time % 60;
  return (
    <Typography variant="h6" color={time < 60 ? 'error' : undefined}>
      Time Left: {min}:{sec.toString().padStart(2, '0')}
    </Typography>
  );
}
